<div class="container-fluid">
  @if (isLoading) {
<loader [config]="{
    fullScreen: false,
    overlay: true,
    type: 'spinner',
    size: 'md',
    text: 'Loading...'
  }"/>
  }

  <div class="row">
    <div class="col-md-4">
      <div class="card h-auto">
        <div class="card-header bg-light">
          <h4 class="card-title">Upload New Document</h4>
        </div>
        <div class="card-body">
          <form [formGroup]="uploadForm">

            <div class="mb-3">
              <div class="custom-file-upload">
                <label for="documentFile" class="btn btn-outline-primary w-100">
                  <i class="fa fa-file me-2"></i>Choose File
                </label>
                @if (selectedFile) {
                  <div class="selected-file mt-3">
                    <span>Selected: <strong>{{ selectedFile.name }}</strong></span>
                  </div>
                }
                @if (!selectedFile) {
                  <div class="selected-file mt-3">
                    <span>No file selected</span>
                  </div>
                }
                <input
                  type="file"
                  class="d-none"
                  id="documentFile"
                  (change)="onFileSelected($event)">
              </div>
            </div>
            <div class="d-grid">
              <button
                type="button"
                class="btn btn-success"
                [disabled]="!uploadForm.valid || !selectedFile || isLoading"
                (click)="uploadDocument()">
                <i class="fa fa-upload me-2"></i>Upload Document
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="col-md-8">
      <div class="card h-100">
        <div class="card-header bg-light">
          <h4 class="card-title">Uploaded Documents</h4>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Document Name</th>
                  <th class="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                @for (document of documents; track document) {
                  <tr>
                    <td>
                      <div class="d-flex align-items-center">
                        <i class="fa fa-file-pdf me-2 text-primary"></i>
                        {{ document.description || 'Unnamed Document' }}
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="d-flex justify-content-center align-items-center">
                        <button class="btn btn-outline-primary btn-sm me-2"
                          (click)="downloadDocument(document)"
                          title="Download Document"
                          [disabled]="isLoading">
                          <i class="fa fa-solid fa-download"></i>
                        </button>
                        <button class="btn btn-outline-danger btn-sm"
                          (click)="deleteDocument(document)"
                          title="Delete Document"
                          [disabled]="isLoading">
                          <i class="fa fa-solid fa-trash"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                }
                @if (documents.length === 0 && !isLoading) {
                  <tr>
                    <td colspan="2" class="text-center">No documents available</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
